import React from 'react';
import cx from 'classnames';
import {Link} from 'gatsby';
import {Button} from 'src/components/button';
import {Price} from 'src/components/price';
import {OrderOptions} from '../order-options';

import {
	useCartTotals,
	useCartItems,
	useCheckout,
	useToggleCart,
} from 'src/context/storeContext';

import {LineItem} from 'src/components/cart/line-item';

import * as styles from './view.module.css';

export const CartView = () => {
	const lineItems = useCartItems();
	const openCheckout = useCheckout();
	const toggleCart = useToggleCart();
	const {total} = useCartTotals();

	return (
		<div className={styles.cartView}>
			<div className={styles.inner}>
				<h2 id="cartLabel" className={cx('headline', styles.title)}>
					Shopping Bag
				</h2>
				{lineItems.length > 0 ? (
					<div className={styles.lineItems}>
						{lineItems.map(item => (
							<LineItem
								item={item}
								key={item.id + item.quantity}
							/>
						))}
					</div>
				) : (
					<h4
						className={cx(
							'body body--large medium',
							styles.emptyMessaging,
						)}
					>
						Your bag is empty.
					</h4>
				)}
				<div className={styles.footer}>
					{lineItems.length > 0 ? (
						<>
							<div>
								<div className="x f jcb aib">
									<span className="label-caps">Subtotal</span>
									<span className="italic price">
										<Price price={total} />
									</span>
								</div>
							</div>
							<OrderOptions />
							<Button
								tag="button"
								onClick={() => openCheckout()}
								className={styles.checkoutButton}
								copy="Check Out"
							/>
						</>
					) : (
						<Link
							className={cx('c-gold', styles.shopCta)}
							onClick={() => toggleCart()}
							to="/"
						>
							<span className="underline-on-hover italic">
								Shop now
							</span>
						</Link>
					)}
				</div>
			</div>
		</div>
	);
};
